import ApiClient from 'clients/api_client'
import DirectIntroduction from 'entities/cooperation/direct_introduction'

export default class DirectIntroductionClient {
  static post(params) {
    const url = Routes.directIntroductionsPath()
    return ApiClient.post(url, params).then(({ data }) => new DirectIntroduction(data))
  }

  static update(id, params) {
    const url = Routes.directIntroductionPath(id)
    return ApiClient.patch(url, params).then(({ data }) => new DirectIntroduction(data))
  }
}
